import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { Clock, Hourglass, ArrowRight } from 'lucide-react';

function DelayNodeComponent({ data, selected }) {
  const delayValue = data.delay_value || 1;
  const delayUnit = data.delay_unit || 'hours';
  const showAnalytics = data.showAnalytics;
  const analytics = data.analytics;
  
  const formatDelay = () => {
    const unitLabels = {
      minutes: delayValue === 1 ? 'minute' : 'minutes',
      hours: delayValue === 1 ? 'hour' : 'hours',
      days: delayValue === 1 ? 'day' : 'days',
    };
    return `${delayValue} ${unitLabels[delayUnit] || delayUnit}`;
  };

  return (
    <div
      className={`
        relative px-4 py-3 rounded-xl border-2 min-w-[160px]
        bg-gradient-to-br from-blue-500/20 to-blue-600/10
        ${selected ? 'border-blue-400 shadow-lg shadow-blue-500/30' : 'border-blue-500/50'}
        transition-all duration-200
      `}
    >
      {/* Input Handle */}
      <Handle
        type="target"
        position={Position.Top}
        className="!w-3 !h-3 !bg-blue-400 !border-2 !border-blue-600"
      />
      
      {/* Node Header */}
      <div className="flex items-center gap-2 mb-1">
        <div className="p-1.5 rounded-lg bg-blue-500/30">
          <Clock className="h-4 w-4 text-blue-400" />
        </div>
        <span className="text-xs font-medium text-blue-400 uppercase tracking-wide">
          Delay
        </span>
      </div>
      
      {/* Delay Value */}
      <div className="text-sm font-semibold text-white">
        Wait {formatDelay()}
      </div>
      
      {/* Inline Analytics - Wait stats */}
      {showAnalytics && analytics && (
        <div className="mt-2 pt-2 border-t border-blue-500/30 flex items-center justify-center gap-2">
          <div className="flex items-center gap-1">
            <Hourglass className="h-3 w-3 text-yellow-400" />
            <span className="text-xs font-bold text-white">{analytics.waiting || 0}</span>
            <span className="text-[10px] text-wt-text-muted">waiting</span>
          </div>
          <div className="flex items-center gap-1">
            <ArrowRight className="h-3 w-3 text-green-400" />
            <span className="text-xs font-bold text-white">{analytics.passed || analytics.completed || 0}</span>
            <span className="text-[10px] text-wt-text-muted">passed</span>
          </div>
        </div>
      )}
      
      {/* Output Handle */}
      <Handle
        type="source"
        position={Position.Bottom}
        className="!w-3 !h-3 !bg-blue-400 !border-2 !border-blue-600"
      />
    </div>
  );
}

export const DelayNode = memo(DelayNodeComponent);
